import { jsx as _jsx } from "react/jsx-runtime";
import { ViewPaymentRequest } from '@src/components/Employee/PaymentRequests/ViewPaymentRequest';
import { ApproveCard } from '@src/components/Manager/ApproveCard';
export const PaymentRequestApproval = ({ approval }) => {
    return (_jsx(ViewPaymentRequest, { id: approval.workflowableId, approval: approval, hideDocuments: true, children: _jsx(ApproveCard, { approval: approval }) }));
};
